<template>
    <div class="flow-line-container">
        <div id="flowLine" class="flow-line"></div>
    </div>
</template>


<script>
  export default {
    props: {
      flowData: Array
    },

    data() {
      return {
        myChart: null
      }
    },
    mounted() {
      // 预防溢出
      // this.$nextTick(() => {
        // this.drawLine()
      // })
    },
    destroyed() {
      this.myChart.dispose()
    },
    methods: {
      drawLine() {
        // 基于准备好的dom，初始化echarts实例
        this.myChart = this.$echarts.init(document.getElementById('flowLine'))
        // 绘制图表
        this.myChart.setOption({
          grid: {
            right: '1%',
            top: '5%',
            left: '5%',
            bottom: '15%'
          },
          xAxis: {
            type: 'category',
            axisLine: {
              show: true,
              lineStyle: {
                color: '#E2E2E2',
                width: 2
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              color: '#666666',
              margin: 20
            },
            splitLine: {
              color: '#EBEBEB',
              width: 1
            }
          },
          yAxis: {
            type: 'value',
            axisLine: {
              show: false
            },
            axisLabel: {
              // color: '#666666',
              margin: 20
            },
            axisTick: { show: false },
          },

          series: [
            {
              type: 'line',
              smooth: 0.4,
              symbol: 'none',
              lineStyle: {
                color: '#6DB9FF',
                width: 2.5
              },
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(
                  0, 0, 0, 1,       //4个参数用于配置渐变色的起止位置, 这4个参数依次对应右/下/左/上四个方位. 而0 0 0 1则代表渐变色从正上方开始
                  [
                    { offset: 0, color: '#6DB9FF' },
                    { offset: 1, color: '#fff' }
                  ]
                )
              },
              data: this.flowData
            }
          ]
        })

        window.addEventListener('resize', () => {
          this.myChart.resize()
        })
      }
    },
        watch: {
      flowData() {
        this.drawLine()
      }
    }
  }
</script>


<style lang="less" scoped>
    .flow-line-container {
        background: white;
        width: 100%;
        height: 300px;

        .flow-line {
            width: 100%;
            height: 100%;
        }
    }
</style>
